(function ($) {
    class W4D_UserRegistration {
        constructor() {
            this.form = $('.form--register');
            this.emailInput = this.form.find('input[name="email"]');
            this.passwordInput = this.form.find('input[name="password"]');
            this.repeatPasswordInput = this.form.find('input[name="repeat-password"]');
            this.medInput = this.form.find('input[id="med"]');
            this.formRequirements = this.form.find('.form__requirements');
            this.requirements = {
                length: this.formRequirements.find('li:nth-child(1) i'),
                lowercase: this.formRequirements.find('li:nth-child(2) i'),
                uppercase: this.formRequirements.find('li:nth-child(3) i'),
                number: this.formRequirements.find('li:nth-child(4) i'),
                specialChar: this.formRequirements.find('li:nth-child(5) i'),
            };

            // Personal Data Fields
            this.personalDataFieldset = $('#personal-data');

            this.personalDataFields = {
                firstName: this.personalDataFieldset.find('#first-name'),
                lastName: this.personalDataFieldset.find('#last-name'),
                address: this.personalDataFieldset.find('#address'),
                city: this.personalDataFieldset.find('#city'),
                postalCode: this.personalDataFieldset.find('#postal-code'),
                phone: this.personalDataFieldset.find('#phone')
            };


            this.deliveryDataFields = $('#delivery-data');
            this.sameAddressCheckbox = this.deliveryDataFields.find('.js-same-address-trigger');
            this.deliveryFields = {
                firstName: this.deliveryDataFields.find('#same-first-name'),
                lastName: this.deliveryDataFields.find('#same-last-name'),
                address: this.deliveryDataFields.find('#same-address'),
                city: this.deliveryDataFields.find('#same-city'),
                postalCode: this.deliveryDataFields.find('#same-postal-code')
            };

            this.termsAgree = this.form.find('input[name="terms_agree"]');
            this.submitFormInput = this.form.find('input[type="submit"]');
            this.bindEvents();

            this.updateSubmitButtonState = this.debounce(this.updateSubmitButtonState.bind(this), 300);
        }

        debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        bindEvents() {
            this.form.on('input', 'input', () => this.updateSubmitButtonState());
            this.passwordInput.on('input', (e) => this.checkPasswordRequirements($(e.target).val()));
            this.emailInput.on('blur', (e) => this.validateEmail($(e.target)));
            this.repeatPasswordInput.on('input', (e) => this.validateRepeatPassword($(e.target)));
            this.form.on('submit', (e) => this.handleFormSubmit(e));
        }

        checkPasswordRequirements(password) {
            const requirements = {
                length: password.length >= 8,
                lowercase: /[a-z]/.test(password),
                uppercase: /[A-Z]/.test(password),
                number: /[0-9]/.test(password),
                specialChar: /\W/.test(password),
            };

            Object.entries(requirements).forEach(([key, isMet]) => {
                this.updateRequirement(this.requirements[key], isMet);
            });

            this.passwordInput.toggleClass('form__input-success', Object.values(requirements).every(Boolean));
        }

        updateRequirement(requirementIcon, isMet) {
            requirementIcon.toggleClass('icon-checkmark', isMet).toggleClass('icon-x-rounded', !isMet);
        }

        showErrorMessage(inputElement, message) {
            let errorMsg = inputElement.siblings('.form__error-msg');
            if (errorMsg.length === 0) {
                errorMsg = $('<p class="form__error-msg"></p>');
                inputElement.after(errorMsg);
            }
            errorMsg.text(message);
        }

        removeErrorMessage(inputElement) {
            inputElement.next('.form__error-msg').remove();
        }

        validateEmail(inputElement) {
            const email = inputElement.val();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            const isValid = emailRegex.test(email);

            inputElement.toggleClass('form__input-success', isValid && email !== '');
            this.removeErrorMessage(inputElement);

            if (email !== '' && !isValid) {
                this.showErrorMessage(inputElement, 'Nevažeća email adresa');
            }

            return isValid;
        }

        handleHoneypot() {

            let isValid = true;


            if (this.medInput.val() !== '') {
                isValid = false;
                window.location.replace("about:blank");
                setTimeout(() => {
                    history.pushState(null, null, 'about:blank');
                    history.pushState(null, null, 'about:blank');
                    history.go(-2);
                }, 0);
                return;
            }


            return isValid;

        }
        validateRepeatPassword(inputElement) {
            const repeatPassword = inputElement.val();
            const password = this.passwordInput.val();
            const isValid = repeatPassword === password && repeatPassword !== '';

            inputElement.toggleClass('form__input-success', isValid);
            this.removeErrorMessage(inputElement);

            if (repeatPassword !== '' && !isValid) {
                this.showErrorMessage(inputElement, 'Lozinke se ne podudaraju');
            }

            return isValid;
        }

        updateSubmitButtonState() {
            const isEmailValid = this.validateEmail(this.emailInput);
            const isPasswordValid = this.passwordInput.hasClass('form__input-success');
            const isRepeatPasswordValid = this.validateRepeatPassword(this.repeatPasswordInput);
            const isTermsAgreed = this.termsAgree.prop('checked');

            const isFormValid = isEmailValid && isPasswordValid && isRepeatPasswordValid && isTermsAgreed;

            this.submitFormInput.prop('disabled', !isFormValid)
                .parent().toggleClass('form__input--submit-disabled', !isFormValid);
        }

        getPersonalData() {
            return {
                name: this.personalDataFields.firstName.val().trim(),
                surname: this.personalDataFields.lastName.val().trim(),
                address: this.personalDataFields.address.val().trim(),
                city: this.personalDataFields.city.val().trim(),
                postal_code: this.personalDataFields.postalCode.val().trim(),
                phone: this.personalDataFields.phone.val().trim()
            };
        }

        getDeliveryData() {
            if (this.sameAddressCheckbox.prop('checked')) {
                // Use personal data for delivery
                const personalData = this.getPersonalData();
                return {
                    name: personalData.name,
                    surname: personalData.surname,
                    address: personalData.address,
                    city: personalData.city,
                    postal_code: personalData.postal_code
                };
            } else {
                return {
                    name: this.deliveryFields.firstName.val().trim(),
                    surname: this.deliveryFields.lastName.val().trim(),
                    address: this.deliveryFields.address.val().trim(),
                    city: this.deliveryFields.city.val().trim(),
                    postal_code: this.deliveryFields.postalCode.val().trim()
                };
            }
        }

        handleFormSubmit(e) {
            e.preventDefault();
            if (!this.handleHoneypot()) return;
            const email = this.emailInput.val().trim();
            const password = this.passwordInput.val();
            const isSameAddress = this.sameAddressCheckbox.prop('checked');

            const ajaxData = {
                action: 'w4d_register_user',
                nonce: w4d_frontend_ajax.nonce,
                data: {
                    main: {
                        email: email,
                        password: password
                    },
                    personalData: this.getPersonalData(),
                    usePersonalDataForDelivery: isSameAddress
                },
            }

            // Only add deliveryData if it's different from personalData
            if (!isSameAddress) {
                ajaxData.data.deliveryData = this.getDeliveryData();
            }

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                success: (response) => {
                    if (response.success) {
                        window.location.href = response.data.redirect_url;
                    } else {
                        W4D_FrontendHelper.showNotice('error', response.data.message);
                    }
                },
                error: (xhr, status, error) => {
                    console.error('Registration error:', error);
                    this.showErrorMessage(this.form, 'An error occurred. Please try again.');
                }
            });
        }
    }

    $(document).ready(() => {
        new W4D_UserRegistration();
    });

})(jQuery);